import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import React from "react";

interface CanNotShipTipProps {
    order: OrderDTO;
}

export function shouldRenderCanNotShipTip(order: OrderDTO) {
    return !!(
        (order.tags?.includes(OrderTag.ALI_CAN_NOT_SHIP) && !!order.aliOrderExtraInfo?.cannotShipReasons) ||
        (order.tags?.includes(OrderTag.CANNOT_SHIP) && !!order.cannotShipReasons)
    );
}

const CanNotShipTip: React.FC<CanNotShipTipProps> = function (props) {
    const { order } = props;

    if (!shouldRenderCanNotShipTip(order)) {
        return null;
    }

    const cannotShipReasons = [];

    for (const tag of order.tags || []) {
        if (tag === OrderTag.ALI_CAN_NOT_SHIP && order.aliOrderExtraInfo?.cannotShipReasons) {
            cannotShipReasons.push(
                <div key={tag}>
                    <span style={{ color: "#f5222d" }}>
                        【该订单暂时不能发货】不可发货原因:{order.aliOrderExtraInfo.cannotShipReasons}
                    </span>
                </div>,
            );
        }

        if (tag === OrderTag.CANNOT_SHIP) {
            // if (order.aliOrderExtraInfo?.cannotShipReasons) {
            //     cannotShipReasons.push(
            //         <div key={tag}>
            //             <span style={{ color: "#f5222d" }}>
            //                 【该订单暂时不能发货】不可发货原因:{order.aliOrderExtraInfo.cannotShipReasons}
            //             </span>
            //         </div>,
            //     );
            // }

            // if (order.taobaoOrderExtraInfo?.cannotShipReasons) {
            //     cannotShipReasons.push(
            //         <div key={tag}>
            //             <span style={{ color: "#f5222d" }}>
            //                 【该订单暂时不能发货】不可发货原因:{order.taobaoOrderExtraInfo.cannotShipReasons}
            //             </span>
            //         </div>,
            //     );
            // }

            if (order?.cannotShipReasons) {
                cannotShipReasons.push(
                    <div key={tag}>
                        <span style={{ color: "#f5222d" }}>
                            【该订单暂时不能发货】不可发货原因:{order.cannotShipReasons}
                        </span>
                    </div>,
                );
            }
        }
    }

    if (!cannotShipReasons.length) return null;

    return <>{cannotShipReasons}</>;
};

export default React.memo(CanNotShipTip);
